import type { ICreatorMinimal } from "./creator.models.types";
import type { IGenreMinimal } from "./genre.models.types";
import type { ILocationMinimal } from "./location.models.types";
import type { IUser } from "./user.models.types";

export enum SocialPlatforms {
  instagram = "instagram",
  youtube = "youtube",
}

export enum SocialContentType {
  clippers = "clippers",
  memers = "memers",
  vibeeditors = "vibeeditors",
  motioneditors = "motioneditors",
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}

export enum SocialGender {
  male = "male",
  female = "female",
  other = "other",
  prefernotsay = "prefernottosay",
}

export enum Platforms {
  solo = "solo",
  memed = "memed",
}

export enum SocialCreatorType {
  face = "face",
  meme = "meme",
}

export enum SocialApplicationStatus {
  draft = "draft",
  created = "created",
  applied = "applied",
  rejected = "rejected",
  approved = "approved",
  external = "external",
  deleted = "deleted"
}


export enum SocialSliderMenuSortOption {
  NEWEST = "newest",
  OLDEST = "oldest",
}

export interface ISocialLocation {
  placeId: string;
  address: string;
}

export interface IApplicationStatus {
  status: SocialApplicationStatus;
  message?: string;
  retryDate?: string;
  timestamp: string;
}

export interface IFixedPayout {
  amount: number;
  status: string;
  timestamp: Date;
  user: IUser;
}

export interface ISocialYoutube {
  channelId: string;
  channelHandle: string;
  channelName: string;
  profileImage: string;
  subscriberCount: number | null;
  accessToken: string;
  refreshToken: string;
  tokenExpiresAt: Date;
  oauthClientId: string;
  metrics: {
    engagementRate: number | null;
    averageViews: number | null;
  } | null;
}

export interface ISocialMinimal {
  id: string;
  creator: ICreatorMinimal | null;
  contentType: Array<SocialContentType> | null;
  platform: SocialPlatforms;
  platformId: string;
  handle: string | null;
  followersCount: number | null;
  engagementRate: number | null;
  averageViews: number | null;
  averageLikes: number;
  averageComments: number;
  profileImage: string | null;
  gender: SocialGender | null;
  genre: Array<IGenreMinimal> | null;
  creatorType: SocialCreatorType | null;
  location: ILocationMinimal | null;
  verified: boolean | null;
  verifiedAt: Date | null;
  applicationStatus: IApplicationStatus;
  isInList: boolean;
  createdAt: Date | null;
  fixedPayout: IFixedPayout | null;
  youtube: ISocialYoutube | null;
}

export interface ISocial extends ISocialMinimal {}
